import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../General/TableWrapper';
import { TableRow, SecondTableTh } from '../General/Table';
import { OrderRow } from './OrderRow';

interface Props {
  orders: any;
  isFetching: boolean;
}

function Orders({ orders, isFetching }: Props) {
  const columns = [
    { name: 'Obj. číslo' },
    { name: 'Dátum' },
    { name: 'Suma', width: '100%' },
    { name: 'Stav', minWidth: rem(148) },
    { name: '' },
  ];
  const headers =
    columns &&
    columns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </SecondTableTh>
    ));

  const orderRows =
    orders &&
    orders.map((order: any) => <OrderRow key={order.order_id} order={order} />);

  return (
    <Wrapper>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <TableWrapper
          tableHasBorder={true}
          tableHasBoxShadow={true}
          noItemsText={__('Nenašli sa žiadne objednávky')}
          headers={headers}
          rows={orderRows}
        />
      )}
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;
  margin-top: ${rem(32)};

  ${({ theme }) => theme.mediab.m810`
       margin: 0;
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

export { Orders };
